<div class="filters-card">
  <!-- Header -->
  <div class="filters-header" (click)="toggle()" role="button" tabindex="0">
    <div class="filters-title">
      <span class="filters-title-text">
        <ng-container *ngIf="config.localizeTitle; else plainTitle">
          {{ config.title | abpLocalization }}
        </ng-container>
        <ng-template #plainTitle>{{ config.title }}</ng-template>
      </span>
    </div>
    <div class="filters-header-actions" (click)="$event.stopPropagation()">
      <ng-container *ngIf="!config.hideActions">
        <app-custom-button [hidden]="isCollapsed" variant="primary" size="sm" (btnClick)="onApply()">
          {{ 'AbpUi::Apply' | abpLocalization }}
        </app-custom-button>

        <app-custom-button [hidden]="isCollapsed" variant="link" size="md" (btnClick)="onClearAll()">
          {{ '::ClearAll' | abpLocalization }}
        </app-custom-button>
      </ng-container>

      <app-custom-button variant="ghost" size="sm" (btnClick)="toggle()">
        <i
          class="fa"
          [class.fa-chevron-up]="!isCollapsed"
          [class.fa-chevron-down]="isCollapsed"
          aria-hidden="true"
        ></i>
      </app-custom-button>
    </div>
  </div>

  <!-- Body -->
  <div class="filters-body" [ngbCollapse]="isCollapsed">
    <div class="row filters-row">
      <ng-container *ngFor="let filter of config.filters; trackBy: trackByFilterKey">
        <div [ngClass]="filter.colClass || 'col-12 col-sm-auto'" class="filter-col">
          <div class="mb-3">
            <!-- Label -->
            <label [for]="'filter-' + filter.key">
              <ng-container *ngIf="filter.localizeLabel !== false; else rawLabel">
                {{ filter.label | abpLocalization }}
              </ng-container>
              <ng-template #rawLabel>{{ filter.label }}</ng-template>
            </label>

            <!-- SELECT -->
            <ng-container *ngIf="filter.type === 'select'">
              <ng-select
                [id]="'filter-' + filter.key"
                class="status-select"
                [ngModel]="filterValues[filter.key]"
                (ngModelChange)="onFilterChange(filter, $event)"
                [ngModelOptions]="{ standalone: true }"
                [items]="filter.options"
                [placeholder]="filter.placeholder || ''"
                bindLabel="key"
                bindValue="value"
                [clearable]="true"
                [multiple]="false"
                [disabled]="filter.disabled === true"
                [attr.aria-describedby]="filter.hint ? 'filter-' + filter.key + '-hint' : null"
              >
                <ng-template ng-option-tmp let-item="item">
                  <div [class.option-disabled]="item.disabled">
                    <ng-container *ngIf="filter.optionLocalizationPrefix; else plainOption">
                      {{ filter.optionLocalizationPrefix + item.value | abpLocalization }}
                    </ng-container>
                    <ng-template #plainOption>{{ item.localizeKey ? (item.key | abpLocalization) : item.key }}</ng-template>
                  </div>
                </ng-template>

                <ng-template ng-label-tmp let-item="item">
                  <ng-container *ngIf="filter.optionLocalizationPrefix; else plainLabel">
                    {{ filter.optionLocalizationPrefix + item.value | abpLocalization }}
                  </ng-container>
                  <ng-template #plainLabel>{{ item.localizeKey ? (item.key | abpLocalization) : item.key }}</ng-template>
                </ng-template>
              </ng-select>
              <div *ngIf="filter.hint" class="filter-hint" [id]="'filter-' + filter.key + '-hint'">
                {{ filter.hint | abpLocalization }}
              </div>
            </ng-container>

            <!-- MULTI-SELECT -->
            <ng-container *ngIf="filter.type === 'multi-select'">
              <ng-select
                [id]="'filter-' + filter.key"
                class="status-select"
                [ngModel]="filterValues[filter.key]"
                (ngModelChange)="onFilterChange(filter, $event)"
                [ngModelOptions]="{ standalone: true }"
                [multiple]="true"
                [items]="filter.options"
                [placeholder]="filter.placeholder || ''"
                [closeOnSelect]="false"
                bindLabel="key"
                bindValue="value"
              >
                <ng-template ng-multi-label-tmp let-items="items">
                  <ng-container *ngIf="items?.length === 1; else multiSelected">
                    {{ items[0]?.key }}
                  </ng-container>
                  <ng-template #multiSelected> {{ items?.length || 0 }} selected </ng-template>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$">
                  <div [class.option-disabled]="item.disabled">
                    <input type="checkbox" [checked]="item$.selected" aria-label="item.key" />
                    <span class="ms-2">{{ item.key }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </ng-container>

            <!-- TEXT -->
            <ng-container *ngIf="filter.type === 'text'">
              <input
                [id]="'filter-' + filter.key"
                type="text"
                class="form-control"
                [ngModel]="filterValues[filter.key]"
                (ngModelChange)="onFilterChange(filter, $event)"
                [ngModelOptions]="{ standalone: true }"
              />
            </ng-container>

            <!-- NUMBER -->
            <ng-container *ngIf="filter.type === 'number'">
              <input
                [id]="'filter-' + filter.key"
                type="number"
                class="form-control"
                [ngModel]="filterValues[filter.key]"
                (ngModelChange)="onFilterChange(filter, $event)"
                [ngModelOptions]="{ standalone: true }"
                [min]="filter.min"
                [max]="filter.max"
              />
            </ng-container>

            <!-- DATE -->
            <ng-container *ngIf="filter.type === 'date'">
              <datetime-picker
                [id]="'filter-' + filter.key"
                [(ngModel)]="filterValues[filter.key]"
                (ngModelChange)="onFilterChange(filter, $event)"
                [ngModelOptions]="{ standalone: true }"
                [allowNull]="true"
                [doNotResetOnInit]="true"
                [doNotDisplayClearButton]="true"
                [showCalendarIconButton]="filter.dateOptions?.showCalendarIcon !== false"
                [showTime]="filter.dateOptions?.showTime ?? false"
              ></datetime-picker>
            </ng-container>

            <!-- DATE RANGE -->
            <ng-container *ngIf="filter.type === 'date-range'">
              <datetime-range-picker
                [id]="'filter-' + filter.key"
                [ngModel]="filterValues[filter.key]"
                (ngModelChange)="onFilterChange(filter, $event)"
                [ngModelOptions]="{ standalone: true }"
                [timePicker]="filter.dateRangeOptions?.timePicker ?? false"
                [timePicker24Hour]="filter.dateRangeOptions?.timePicker24Hour ?? true"
                [opens]="filter.dateRangeOptions?.opens ?? 'center'"
                [drops]="filter.dateRangeOptions?.drops ?? 'down'"
                [customPresets]="filter.dateRangeOptions?.customPresets ?? undefined"
                [minDate]="filter.dateRangeOptions?.minDate ?? null"
              ></datetime-range-picker>
            </ng-container>

            <!-- ORGANIZATION UNIT -->
            <ng-container *ngIf="filter.type === 'organization-unit'">
              <app-organization-unit-selector
                [id]="'filter-' + filter.key"
                [(ngModel)]="filterValues[filter.key]"
                [ngModelOptions]="{ standalone: true }"
                (organizationUnitChange)="filter.onChange ? filter.onChange($event) : null"
                [organizationUnitSource]="filter.organizationUnitSource"
                [title]="filter.title"
              ></app-organization-unit-selector>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!-- Custom content projection for special cases -->
      <ng-content></ng-content>
    </div>
  </div>
</div>
